import styled, { css } from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.div`
  width: 100vw;
  height: 100%;
  min-height: 83vh;

  display: flex;
  align-items: center;
  justify-content: center;

  background: rgba(243, 241, 238, 0.93);

  ${media.greaterThan('small')`
    max-width: 45rem;
    border-radius: 1.5rem 1.5rem 0 0;
  `}
`;

export const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  width: 80%;

  padding: 2rem 1.8rem;
  border-radius: 5px;

  box-shadow: 0px 0px 16px rgba(228, 231, 231, 1);

  ${({ theme }) => css`
    background: ${theme.colors.white};
    > p {
      color: ${theme.colors.highContrast};
    }
  `}

`;

export const Header = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 1.5rem;

  > strong {
    margin-left: 1.5rem;
  }

  ${({ theme }) => css`
    color: ${theme.colors.primary};
  `}
`;
